import React, { useEffect } from 'react';
import { toast } from 'react-toastify';

import { isArray } from 'lodash';
//import moment from 'moment';
import PropTypes from 'prop-types';
import * as Yup from 'yup';

import { Autocomplete, Input } from '~/components/Form';

import { t } from '~/helpers';
import api from '~/services/api';

import { ContainerForm } from './styles';

export default function MyForm({ data, reference, close }) {

  const [valuePosto, setValuePosto] = React.useState(0);
  const [inputValuePosto, setInputValuePosto] = React.useState('');


  async function handleSubmit(param) {
    try {

      const schema = Yup.object().shape({        
          poco_codigo: Yup.number()
          .required(t('s.geral.validacao.campoobrigatorio'))
          .transform((value) => (isNaN(value) ? undefined : value))
          .integer(t('s.geral.validacao.campoobrigatorio'))
          .min(1, t('s.geral.validacao.campoobrigatorio').replace('%s', 0)),
      });

      await schema.validate(param, {
        abortEarly: false,
      });

      const objSend = {
        codNovo: param.poco_codigo,
        codPostoOld: data.poco_codigo,
        idlogin: '',
      };

      await api.put('executamigrapostosusuario', objSend);
      toast.success(t('s.geral.sucessoalteracao'));

      await close();
    } catch (err) {
      if (isArray(err)) {
        err.map((e) => toast.error(e));
      }

      const validationErrors = {};

      if (err instanceof Yup.ValidationError) {
        err.inner.forEach((error) => {
          validationErrors[error.path] = error.message.replace(
            `${error.path} `,
            ''
          );
        });

        reference.current.setErrors(validationErrors);
      }
    }
  }

  useEffect(() => {
    reference.current.setData(data);
  }, []);

  return (
    <>
      <ContainerForm ref={reference} initialData={data} onSubmit={handleSubmit}>

        <Input
          name="poco_descricao"
          label='Posto origem:'
          value={data.poco_descricao}
          disabled
        />


        <Autocomplete
          name="poco_codigo"
          label="poco_desc_abrev"
          title="Posto destino"
          id="poco_codigo"
          url="postoscomboios"
          unique="poco_codigo"

          value={valuePosto}
          inputValue={inputValuePosto}
          onChange={(event, newValue) => {
            setValuePosto(newValue);
          }}
          onInputChange={(event, newInputValuePosto) => {
            setInputValuePosto(newInputValuePosto);
          }}          
          hiddens={[{ name: 'poco_desc_abrev' }]}
          getValue={(value) => {
            if (value.poco_codigo !== null) {
              setValuePosto(value.poco_codigo);
            } else {
              setValuePosto(0);
            }
          }}
        />

      </ContainerForm>
    </>
  );
}

MyForm.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
  reference: PropTypes.objectOf(PropTypes.any).isRequired,
  close: PropTypes.func.isRequired,
};
